import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiTarget, FiAward, FiUsers, FiBarChart2 } from 'react-icons/fi';
import backofficeService from '../../../services/backofficeService';
import './Dashboard.css';

const Dashboard = () => {
  const [stats, setStats] = useState({
    bets: 0,
    challenges: 0,
    partners: 0,
  });
  const [recentBets, setRecentBets] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const [bets, challenges, partners] = await Promise.all([
        backofficeService.getBets(),
        backofficeService.getChallenges(),
        backofficeService.getPartners(),
      ]);

      setStats({
        bets: bets.length,
        challenges: challenges.length,
        partners: partners.length,
      });

      setRecentBets(bets.slice(0, 5));
    } catch (error) {
      console.error('Erro ao carregar dados:', error);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className="backoffice-page">
        <div className="loading-state">
          <div className="loading-spinner"></div>
          <p>A carregar...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="backoffice-page dashboard">
      <div className="page-header">
        <h1>Dashboard</h1>
      </div>

      <div className="stats-grid">
        <Link to="/backoffice/bets" className="stat-card">
          <FiTarget className="stat-icon" />
          <h3>Total de Bets</h3>
          <div className="stat-value">{stats.bets}</div>
        </Link>

        <Link to="/backoffice/challenges" className="stat-card">
          <FiAward className="stat-icon" />
          <h3>Desafios Ativos</h3>
          <div className="stat-value">{stats.challenges}</div>
        </Link>

        <Link to="/backoffice/partners" className="stat-card">
          <FiUsers className="stat-icon" />
          <h3>Parceiros</h3>
          <div className="stat-value">{stats.partners}</div>
        </Link>
      </div>

      <div className="dashboard-section">
        <div className="section-header">
          <h2>Bets Recentes</h2>
          <Link to="/backoffice/bets" className="btn-secondary">
            Ver todas
          </Link>
        </div>

        {recentBets.length > 0 ? (
          <table className="data-table">
            <thead>
              <tr>
                <th>Data</th>
                <th>Jogos</th>
                <th>Odd Total</th>
                <th>Montante</th>
                <th>Estado</th>
                <th>Modificado por</th>
              </tr>
            </thead>
            <tbody>
              {recentBets.map((bet) => (
                <tr key={bet.id}>
                  <td>{bet.date}</td>
                  <td>{bet.games?.length || 0} jogos</td>
                  <td>{bet.total_odd || '-'}</td>
                  <td>{bet.amount || '-'}</td>
                  <td>
                    <span className={`status-badge ${getStatusClass(bet.result)}`}>
                      {getStatusLabel(bet.result)}
                    </span>
                  </td>
                  <td>
                    <span className="modified-by">{bet.modified_by_username || '-'}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="empty-state">
            <FiBarChart2 className="empty-state-icon" />
            <h3>Sem bets registadas</h3>
            <p>Comece a adicionar bets para vê-las aqui.</p>
          </div>
        )}
      </div>
    </div>
  );
};

const getStatusClass = (result) => {
  if (!result || result === 'pending') return 'warning';
  if (result === 'won') return 'success';
  if (result === 'lost') return 'danger';
  if (result === 'void') return 'secondary';
  return 'warning';
};

const getStatusLabel = (result) => {
  if (!result || result === 'pending') return 'Pendente';
  if (result === 'won') return 'Ganho';
  if (result === 'lost') return 'Perdido';
  if (result === 'void') return 'Anulada';
  return 'Pendente';
};

export default Dashboard;
